import React from "react";
import SwiperCore, { Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.scss";
import { HeaderMain, Message } from "./style.js";
import { Container, CTA } from "components/shared";

SwiperCore.use([Autoplay]);

const MESSAGES = [
    "😊 I build websites 😊",
    "💸 I help business grow 💸",
    "💻 I'm a Front End Developer 💻",
];

export default function Header() {
    return (
        <HeaderMain>
            <Container>
                <Message>
                    <h2>
                        Hello , I'm <span>Nico</span>!{" "}
                    </h2>
                    <h3>
                        <Swiper
                            loop
                            slidesPerView="1"
                            autoplay={{ delay: 2000 }}
                        >
                            {MESSAGES.map((item) => (
                                <SwiperSlide key={item}>{item}</SwiperSlide>
                            ))}
                        </Swiper>
                    </h3>

                    <CTA href="#works">See Works</CTA>
                </Message>
            </Container>
        </HeaderMain>
    );
}
